import FunctionsIcon from '@mui/icons-material/Functions';
import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { VariableMatchViewDetailsButton } from './VariableMatchViewDetailsButton';
import type { VariableMatchSummaryItem } from '../types/variable-match-types';

interface VariableMatchSummaryRowProps {
  item: VariableMatchSummaryItem;
}

/**
 * One variable's outcome on the review and resolved screens: the "Match for X"
 * context restated from its step, then the pick with a link to its details.
 */
export const VariableMatchSummaryRow = ({ item }: VariableMatchSummaryRowProps) => (
  <Stack
    spacing={1}
    data-testid={`variable-match-summary-${item.checkpointId}`}
    sx={{
      paddingY: 3,
      borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      '&:last-of-type': { borderBottom: 'none' },
    }}
  >
    <Typography variant="body2" color="text.secondary">
      <FormattedMessage
        id="epiChat.variableMatch.matchFor"
        defaultMessage="Match for <strong>{name}</strong>"
        values={{
          name: item.requestedLabel,
          strong: (chunks) => (
            <Box component="strong" sx={{ fontWeight: 600, color: 'text.primary' }}>
              {chunks}
            </Box>
          ),
        }}
      />
    </Typography>
    <Stack direction="row" alignItems="center" spacing={2}>
      <FunctionsIcon sx={{ fontSize: 16, color: 'primary.main', flexShrink: 0 }} aria-hidden />
      <Typography variant="body2" color="text.secondary" sx={{ flex: 1, minWidth: 0 }}>
        {item.selectionLabel}
      </Typography>
      {item.reusedCandidate && <VariableMatchViewDetailsButton candidate={item.reusedCandidate} />}
    </Stack>
  </Stack>
);
